import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { articleById, getActiveArticleCategory, updateArticle } from '../../../actions/utilitiesAction'
import Add from '../../../component/Utilities/Article/AddArticle'
import constant from '../../../constant'
const EditArticle = () => {
    const [response, setResponse] = React.useState({})
    const [showMsg, setShowMsg] = React.useState(false)

    const navigate = useNavigate()
    const params = useParams()
    const [data, setData] = useState(null)
    const [list, setList] = useState([])

    useEffect(() => {

        articleById(parseInt(params.id)).then((res) => {
            if (res.status) {
                setData(res.result)
            }
            else {
                setResponse(res)
                setShowMsg(true)
                setTimeout(() => {
                    setShowMsg(false)
                }, 7000)
            }
        }).catch(err => {
            alert(err)
        })
        getActiveArticleCategory().then((res) => {
            setList(res.result)
        }).catch((err) => {
            alert(err)
        })
    }, [])
    // getActiveBlogCategory().then((res) => {
    //     console.log(res.result);
    //     setList(res.result)
    // }).catch((err) => {
    //     alert(err)
    // })


    const onSubmit = (model) => {
        updateArticle(model).then((res) => {
            if (res.status) {
                navigate(constant.component.listArticle.url)
            } else {
                setResponse(res)
                setShowMsg(true)
                setTimeout(() => {
                    setShowMsg(false)
                }, 7000)
            }
        }).catch((err) => {
            alert(err)
        })

    }

    return (
        <React.Fragment>
            {data && <Add onSubmit={onSubmit} detail={data} response={response} showMsg={showMsg} list={list} />}
        </React.Fragment>
    )
}
export default EditArticle;